<template>
  <div>
    <img
      ref="icono-acreditado"
      src="@/assets/img/iconos/acreditacion-1.svg"
      :class="classImg"
      :style="styleImg"
      v-if="acreditacion === 1"
    />
    <img
      ref="icono-acreditado"
      src="@/assets/img/iconos/acreditacion-2.svg"
      :class="classImg"
      :style="styleImg"
      v-else-if="acreditacion === 2"
    />
    <img
      ref="icono-acreditado"
      src="@/assets/img/iconos/acreditacion-3.svg"
      :class="classImg"
      :style="styleImg"
      v-else-if="acreditacion === 3"
    />
    <img
      ref="icono-acreditado"
      src="@/assets/img/iconos/acreditacion-4.svg"
      :class="classImg"
      :style="styleImg"
      v-else-if="acreditacion === 4"
    />
    <img
      ref="icono-acreditado"
      src="@/assets/img/iconos/acreditacion-5.svg"
      :class="classImg"
      :style="styleImg"
      v-else-if="acreditacion === 5"
    />
    <img
      ref="icono-acreditado"
      src="@/assets/img/iconos/acreditacion-6.svg"
      :class="classImg"
      :style="styleImg"
      v-else-if="acreditacion === 6"
    />
    <img
      ref="icono-acreditado"
      src="@/assets/img/iconos/acreditacion-7.svg"
      :class="classImg"
      :style="styleImg"
      v-else-if="acreditacion === 7"
    />
    <img
      ref="icono-acreditado"
      src="@/assets/img/iconos/acreditacion-8.svg"
      :class="classImg"
      :style="styleImg"
      v-else
    />
    <span v-if="mostrarTextoLateral">{{textoLateral}}</span>
    <b-tooltip
      :disabled.sync="tooltipDisabled"
      :target="() => $refs['icono-acreditado']"
      :title="acreditacionText"
    ></b-tooltip>
  </div>
</template>

<script>
export default {
  name: "AñoAcreditacion",
  props: {
    acreditacion: {
      type: Number
    },
    classImg: {
      type: String
    },
    classDiv: {
      type: String
    },
    styleImg: {
      type: String
    },
    tooltipDisabled: {
      type: Boolean,
      default: true
    },
    mostrarTextoLateral:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    acreditacionText() {
      let text = this.acreditacion === 1 ? "año" : "años";
      return `Institución acreditada: ${this.acreditacion} ${text}`;
    },
    textoLateral() {
      let text = this.acreditacion === 1 ? "año" : "años";
      return ` ${this.acreditacion} ${text}`;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/generales/iconos/AniosAcreditacion.vue